module.exports = __webpack_public_path__ + "img/SMT_27_Ms_Angeline_Thia.0b44026f.jpg";